import {
  createTaskEditorBlock,
  migrateTaskEditorStateFromLegacy,
  TaskEditorState,
} from "./taskEditorUtils";

export const cloneTaskEditorState = (
  state: TaskEditorState | unknown
): TaskEditorState => migrateTaskEditorStateFromLegacy(state);

export const createEmptyTaskEditorState = (): TaskEditorState => ({
  task_id: "",
  title: "",
  blocks: [createTaskEditorBlock()],
});
